import script from "./SetupSpendingAnalysisPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SetupSpendingAnalysisPage.vue?vue&type=script&setup=true&lang=ts"

import "./SetupSpendingAnalysisPage.vue?vue&type=style&index=0&id=5e7034cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e7034cc"]])

export default __exports__